import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "radio", "cardBody", "submitBtn", "ownershipModal", "ownershipModalLink"]

  select() {
    const selectedRadio = this.radioTargets.find(r => r.checked)
    if (!selectedRadio) return

    const selectedIdx = selectedRadio.value
    const selectedCard = this.cardTargets.find(c => c.dataset.slotIdx === selectedIdx)

    if (selectedCard && selectedCard.dataset.needsOwnership === "true") {
      this._showOwnershipModal(selectedCard.dataset.slotAccountId)
      selectedRadio.checked = false
      return
    }

    this.cardTargets.forEach(card => {
      const body = card.querySelector("[data-slot-selector-target='cardBody']")
      if (!body) return

      if (card.dataset.slotIdx === selectedIdx) {
        body.style.borderColor = "#39FF14"
        body.style.boxShadow = "0 0 30px rgba(57,255,20,0.12), 0 0 60px rgba(57,255,20,0.04)"
      } else {
        const radio = card.querySelector("input[type='radio']")
        if (radio && !radio.disabled) {
          body.style.borderColor = "rgba(57,255,20,0.3)"
          body.style.boxShadow = "none"
        }
      }
    })

    if (!this.hasSubmitBtnTarget) return

    const btn = this.submitBtnTarget
    btn.disabled = false
    btn.style.background = "rgba(57,255,20,0.1)"
    btn.style.color = "#39FF14"
    btn.style.borderColor = "rgba(57,255,20,0.4)"
    btn.style.cursor = "pointer"
    btn.style.boxShadow = "0 0 20px rgba(57,255,20,0.1)"
  }

  closeOwnershipModal() {
    if (this.hasOwnershipModalTarget) {
      this.ownershipModalTarget.classList.add("hidden")
    }
  }

  _showOwnershipModal(slotAccountId) {
    if (!this.hasOwnershipModalTarget) return

    if (this.hasOwnershipModalLinkTarget && slotAccountId) {
      this.ownershipModalLinkTarget.href = `/accounts/${slotAccountId}`
    }

    this.ownershipModalTarget.classList.remove("hidden")
  }
}
